import { InsightData } from 'schemas/action/InsightDataSchema'
import { DashboardWidgetWithPivotThemeType } from 'features/dashboard/types'
import { WidgetSettingComposingStrategy } from '../widgetSettingComposingStrategy'
import { DecoratedWidgetSettingComposingStrategy } from './type'

const hasTagBeenIncluded = (
  includedUserTags: ((string | undefined)[] | undefined)[] | undefined,
  tagName: string
) =>
  includedUserTags &&
  includedUserTags.some((tags) => tags && tags.length === 1 && tags.includes(tagName))

const pivotTagDecorator = (
  applicationSettings: any,
  strategy: WidgetSettingComposingStrategy
): DecoratedWidgetSettingComposingStrategy => ({
  ...strategy,
  canBeDrilledDown: (widgetSetting: DashboardWidgetWithPivotThemeType) => {
    if (
      widgetSetting.includedUserTags &&
      widgetSetting.includedUserTags.length >= applicationSettings.analysisUserTagFilterCount
    ) {
      return false
    }

    return strategy.canBeDrilledDown(widgetSetting)
  },
  composeDrillDownWidgetSetting: (
    widgetSetting: DashboardWidgetWithPivotThemeType,
    insights: InsightData[],
    pivots: InsightData[]
  ) => {
    const alteredWidgetSetting = strategy.composeDrillDownWidgetSetting(widgetSetting, insights)
    const notIncludedTags = pivots.filter(
      (pivot) => !hasTagBeenIncluded(alteredWidgetSetting.includedUserTags, pivot.name!)
    )

    if (notIncludedTags.length === 0) {
      return alteredWidgetSetting
    }

    return {
      ...alteredWidgetSetting,
      includedUserTags: [
        ...(alteredWidgetSetting.includedUserTags || []),
        notIncludedTags.map((tag) => tag.name!)
      ]
    }
  }
})

export default pivotTagDecorator
